'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var addFocusVisibleClass = function addFocusVisibleClass(el) {
  if (el.classList.contains('fr-ec-show-focus-border')) {
    return;
  }
  el.classList.add('fr-ec-show-focus-border');
};
var removeFocusVisibleClass = function removeFocusVisibleClass(el) {
  if (!el.classList.contains('fr-ec-show-focus-border')) {
    return;
  }
  el.classList.remove('fr-ec-show-focus-border');
};
var onKeyDown = function onKeyDown(docElement) {
  return function (e) {
    if (e.key !== 'Tab') {
      removeFocusVisibleClass(docElement.body);
      return;
    }
    addFocusVisibleClass(docElement.body);
  };
};
var onPointerDown = function onPointerDown(docElement) {
  return function () {
    removeFocusVisibleClass(docElement.body);
  };
};
var applyKeyboardFocus = function applyKeyboardFocus(docElement) {
  docElement.addEventListener('keydown', onKeyDown(docElement), true);
  docElement.addEventListener('mousedown', onPointerDown(docElement), true);
  docElement.addEventListener('pointerdown', onPointerDown(docElement), true);
  docElement.addEventListener('touchstart', onPointerDown(docElement), true);
};
var keyboardOnlyFocus = function keyboardOnlyFocus(docElement) {
  if (docElement === void 0) {
    docElement = document;
  }
  if (typeof docElement !== 'undefined') {
    applyKeyboardFocus(docElement);
  }
};

exports.keyboardOnlyFocus = keyboardOnlyFocus;
